import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { listenToDoc } from '@/utils/getDataFromDb';
import TeamHeader from '@/components/SHARED/team-header/team-header.component';
import TeamRoster from '@/components/SHARED/team-roster/team-roster.component';
import TeamSchedule from '@/components/SHARED/team-schedule/team-schedule.component';
import RankChart from '@/components/SHARED/rank-chart/rank-chart.component';
import TeamHistory from '@/components/SHARED/team-history/team-history.component';
import TeamRivals from '@/components/SHARED/team-rivals/team-rivals.component';
import RecruitClass from '@/components/SHARED/recruit-class/recruit-class.component';
import TeamScouting from '@/components/SHARED/team-scouting/team-scouting.component';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';

// Another team in the league, as any manager sees it.
const TeamPage = ({ league, teams, schedule, teamLink, gameLink, playerLink, seasonLink, rankHistory, scoutLink }) => {

    const { teamId } = useParams();
    const [ team, setTeam ] = useState(undefined);

    useEffect(() => {
        setTeam(undefined);
        let unsub;
        listenToDoc({
            'path': `leagues/${league.id}/teams/${teamId}`,
            'callback': setTeam,
            'handleListener': (u) => { unsub = u; },
        });
        return () => { if (unsub) unsub(); }
    }, [league.id, teamId])

    if (team === undefined) return <div className='center-col'><ThreeDotsLoader /></div>;
    if (team === null) return <p className='meta'>Team not found.</p>;

    const conf = league.conferences[team.conference];
    return (
        <div className='manager-league team-page'>
            <TeamHeader
                league={league}
                teams={teams}
                team={team}
                meta={`${conf?.name ?? ''} · ${team.managerId ? `Managed by ${team.managerName ?? 'a user'}` : 'Computer-managed'}`} />
            {rankHistory &&
                <div className='g-card'>
                    <RankChart
                        history={rankHistory}
                        teamId={teamId}
                        title={league.type === 'pro' ? 'Power ranking' : 'Ranking'}
                        top25={league.type !== 'pro'}
                        regularDays={league.season.totalDays} />
                </div>
            }
            <TeamScouting team={team} reportLink={scoutLink?.(teamId)} />
            <div className='g-card'>
                <h3>Roster</h3>
                <TeamRoster team={team} playerLink={playerLink} />
            </div>
            <div className='g-card'>
                <h3>Schedule</h3>
                <TeamSchedule teamId={teamId} schedule={schedule} year={league.season.year} teams={teams} gameLink={gameLink} teamLink={teamLink} />
            </div>
            <RecruitClass team={team} />
            <TeamRivals team={team} teams={teams} teamLink={teamLink} />
            <TeamHistory team={team} league={league} seasonLink={seasonLink} />
        </div>
    )
}

export default TeamPage
